"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_ORDER_SORT_BY = exports.WORK_ORDER_PRIORITY = exports.WORK_ORDER_STATUS = exports.WORK_ORDER_CREATION_STATUS = void 0;
exports.WORK_ORDER_CREATION_STATUS = {
    IN_PROGRESS: 'in_progress',
    COMPLETE: 'complete',
};
exports.WORK_ORDER_STATUS = {
    OPEN: {
        id: 1,
        name: 'Open',
    },
    IN_PROGRESS: {
        id: 2,
        name: 'In Progress',
    },
    ON_HOLD: {
        id: 3,
        name: 'On Hold',
    },
    DONE: {
        id: 4,
        name: 'Done',
    },
};
exports.WORK_ORDER_PRIORITY = {
    LOW: {
        id: 1,
        name: 'Low',
    },
    MEDIUM: {
        id: 2,
        name: 'Medium',
    },
    HIGH: {
        id: 3,
        name: 'High',
    },
    URGENT: {
        id: 4,
        name: 'Urgent',
    },
};
exports.WORK_ORDER_SORT_BY = {
    NEWEST: 'newest',
    OLDEST: 'oldest',
    STATUS: 'status',
    HIGHEST_PRIORITY: 'highestPriority',
    LOWEST_PRIORITY: 'lowestPriority',
    DUE_SOONEST: 'dueSoonest',
    DUE_LATEST: 'dueLatest',
    ISSUE_TYPE_ASC: 'issueTypeAsc',
    ISSUE_TYPE_DESC: 'issueTypeDesc',
    PROPERTY_ASC: 'propertyAsc',
    PROPERTY_DESC: 'propertyDesc',
};
//# sourceMappingURL=work-order.types.js.map